import { render } from "./CertificatesComponent.vue?vue&type=template&id=186698d7"
import script from "./CertificatesComponent.vue?vue&type=script&lang=js"
export * from "./CertificatesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__